import styled from "styled-components";

interface IInputForm {
	hasError: boolean;
}

export const Form = styled.form<IInputForm>`
	width: 100%;

	display: flex;
	align-items: flex-start;
	justify-content: center;

	flex-direction: column;

	margin-bottom: 22px;

	>p{
		font-size: 14px;
		color: ${props => props.theme.palette.greyscale.grey900};
	}

	span{
		font-size: 12px;
		color: ${props => props.theme.palette.greyscale.grey600};
	}
	
	#mask-input{
		width: 100%;

		padding: 8px;

		border: 0;
		border-bottom: ${props => !!props.hasError ? "2px solid #FF3838" : `1px solid ${props.theme.palette.greyscale.grey200}`};

		margin-bottom: 24px;

		background: transparent;

		font-size: 16px;
		color: ${props => props.theme.palette.greyscale.grey900};
	}

	>button{
		width: 100%;

		padding: 10px 24px;

		background: ${props => props.theme.palette.primary.blue400};

		border: 0;
		border-radius: 5px;

		margin-top: 12px;

		font-size: 13px;
		font-weight: 600;
		color: #FFF;

		cursor: pointer;
		transition: background-color 0.3s ease;

		&:hover:not(:disabled) {
			background-color: ${props => props.theme.palette.primary.blue500};
		}

		&:disabled {
			background-color: ${props => props.theme.palette.greyscale.grey300};
			cursor: not-allowed;
			opacity: 0.7;
		}
	}

	>label{
		width: 100%;

		padding: 10px 24px;

		background: #FFF;

		border: 2px solid ${props => props.theme.palette.primary.blue400};
		border-radius: 5px;

		margin-top: 12px;

		font-size: 13px;
		font-weight: 600;
		color: ${props => props.theme.palette.primary.blue400};

		cursor: pointer;
		text-align: center;
		transition: all 0.3s ease;

		&:hover {
			background-color: ${props => props.theme.palette.primary.blue50};
		}
	}

	@media(max-width: ${props => props.theme.breakpoints.tablet}){
		width: 85%;

		>p{
			display: flex;
			align-items: center;
			justify-content: flex-start;

			font-size: 13px;

			>span{
				font-size: 10px;
			}
		}

		>button{
			font-size: 12px;
		}

		>label{
			font-size: 12px;
		}
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		>p{
			font-size: 16px;
		}

		span{
			font-size: 14px;
		}

		>button{
			margin-top: 0px;

			font-size: 15px;

			padding: 12px 24px;
		}

		>label{
			margin-top: 0px;

			font-size: 15px;

			padding: 12px 24px;
		}
	}
`;

export const InputForm = styled.input<IInputForm>`
	width: 100%;

	padding: 4px 8px 8px;

	border: 0;
	border-bottom: ${props => !!props.hasError ? "2px solid #FF3838" : `1px solid ${props.theme.palette.greyscale.grey200}`};

	margin-bottom: 24px;

	background: transparent;

	font-size: 16px;
	color: ${props => props.theme.palette.greyscale.grey900};

	&:focus {
		outline: none;
		border-bottom-color: ${props => !!props.hasError ? "#FF3838" : props.theme.palette.primary.blue500};
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		padding: 8px;

		margin-bottom: 38px;
	}
`;

export const UserTypes = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	width: 100%;

	padding: 16px;

	background: ${props => props.theme.palette.greyscale.grey50};

	margin-bottom: 24px;

	>div{
		display: flex;
		align-items: center;
		justify-content: center;

		border: 0;

		cursor: pointer;

		label{
			font-size: 14px;
			color: ${props => props.theme.palette.greyscale.grey700};

			cursor: pointer;

			@media(max-width: ${props => props.theme.breakpoints.tablet}){
				font-size: 12px;
			}
		}

		& + div{
			margin-left: 48px;
		}
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		>div{
			>label{
				font-size: 18px;
			}
		}
	}
`;

export const SocialButtonsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	margin-bottom: 16px;

	@media(max-width: ${props => props.theme.breakpoints.tablet}){
		gap: 10px;
		margin-bottom: 14px;
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		gap: 14px;
		margin-bottom: 18px;
	}
`;

export const Divider = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	width: 100%;
	margin: 16px 0;
	color: ${props => props.theme.palette.greyscale.grey500};
	font-size: 12px;
	font-weight: 500;

	&::before,
	&::after {
		content: '';
		flex: 1;
		height: 1px;
		background-color: ${props => props.theme.palette.greyscale.grey200};
	}

	@media(max-width: ${props => props.theme.breakpoints.tablet}){
		margin: 14px 0;
		font-size: 11px;
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		margin: 18px 0;
		font-size: 13px;
	}
`;

export const OthersLoginOptions = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	width: 100%;

	.kep-login-facebook.metro {
	    border-radius: 5px;

	    >svg{
			margin-left: 35%;
	    	margin-right: 8px;
	    }
	}

	>span{
		width: 100%;
	}

	button{
		display: flex;
		align-items: center;
		justify-content: flex-start;

		font-size: 12px;
		font-weight: 600;
		color: ${props => props.theme.palette.greyscale.grey500};

		padding: 6px 18px;

		background: transparent;

		border: 1px solid ${props => props.theme.palette.greyscale.grey200};
		border-radius: 5px;

		width: 100%;

		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			background-color: ${props => props.theme.palette.greyscale.grey50};
			border-color: ${props => props.theme.palette.greyscale.grey300};
		}

		>p{
			margin: 0 auto;

			font-size: 15px;
		}

		& + span{
			margin-left: auto;
		}
	}

	@media(max-width: ${props => props.theme.breakpoints.tablet}){
		width: 85%;

		.kep-login-facebook.metro {
		    >svg{
		    	margin-right: 8px;
		    }
		}

		button{
			padding: 8px 18px;

			font-size: 9px;

			width: 100%;

			>svg{
				width: 15px;
				height: 15px;
			}

			>p{
				font-size: 9px;
			}
		}
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		.kep-login-facebook.metro {
		    >svg{
		    	width: 26px;
				height: 26px;
		    }
		}
	}
`;